import {NFeRT} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getCSTcClassTrib(context, item) {
        return NFeRT.getCSTcClassTrib(item).then((response) => {
            return response.data;
        });
    },
    getIBS(context, item) {
        return NFeRT.getIBS(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
